import {Route,Switch,BrowserRouter } from "react-router-dom";

import FaqCategoryTable from "components/Doobi/FaqCategory";
import FaqTable from "components/Doobi/Faq";
import DoobiHeader from "components/Headers/DoobiHeader";

const FaqRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Faq" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/:id`} component={FaqTable}/>
      <Route path={`${match.path}/`} component={FaqCategoryTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default FaqRoute;
